module.exports = __webpack_public_path__ + "static/media/Galdisa_Ficha_cacahuate_español.376fe820.pdf";